import { render } from "./ShopList.vue?vue&type=template&id=089bf69c&scoped=true"
import script from "./ShopList.vue?vue&type=script&lang=js"
export * from "./ShopList.vue?vue&type=script&lang=js"

import "./ShopList.vue?vue&type=style&index=0&id=089bf69c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-089bf69c"]])

export default __exports__